<template>
  <article class="car_card">
    <router-link :to="car.path" class="car_card_photo">
      <img :src="car.cover" :alt="car.name" width="950" height="713" loading="lazy" />
    </router-link>

    <div class="car_card_body">
      <h3><router-link :to="car.path">{{ car.name }}</router-link></h3>
      <p class="car_card_year">{{ car.year }}</p>

      <dl class="car_card_specs">
        <div>
          <dt>Przebieg</dt>
          <dd>{{ car.mileage }}</dd>
        </div>
        <div>
          <dt>Moc</dt>
          <dd>{{ car.power }}</dd>
        </div>
        <div>
          <dt>Skrzynia</dt>
          <dd>{{ car.gearbox }}</dd>
        </div>
      </dl>

      <div class="car_card_footer">
        <div>
          <p class="car_card_label">Cena brutto</p>
          <p class="car_card_price">{{ car.price }}</p>
        </div>
        <router-link :to="car.path" class="site_button">Zapytaj</router-link>
      </div>
    </div>
  </article>
</template>

<script>
// One car in the stock listing (see src/data/cars.js).

export default {
  name: 'CarCard',

  props: {
    car: { type: Object, required: true },
  },
}
</script>

<style scoped>
.car_card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--paper-line);
  border-radius: var(--radius);
  overflow: hidden;
}

.car_card_photo img {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.car_card_photo:hover img {
  transform: scale(1.03);
}

.car_card_body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 24px;
}

.car_card h3 {
  font-size: 26px;
}

.car_card_year {
  margin-top: 4px;
  color: var(--ink-muted);
}

.car_card_specs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin: 24px 0;
  padding: 24px 0;
  border-top: 1px solid var(--paper-line);
  border-bottom: 1px solid var(--paper-line);
}

.car_card_specs dt,
.car_card_label {
  color: rgba(10, 10, 11, 0.61);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.car_card_specs dd {
  margin: 0;
}

.car_card_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: auto;
}

.car_card_price {
  color: var(--ink);
  font-size: 26px;
  font-weight: 600;
}
</style>
